import React from "react";
import { Outlet } from "react-router-dom";
import "../home.css";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppWidget } from "./WhatsAppWidget";

export const Layout = () => (
    <div className="container">
        <Header />
        <div className="content detail-content">
            <div className="wrapper">
                <Outlet />
                <Footer />
            </div>
        </div>
        <WhatsAppWidget />
    </div>
);
